import { useState } from "react";
import { BackgroundWrapper } from "../../atoms/backgroundWrapper/BackgroundWrapper";
import { Container } from "../../atoms/container/Container";
import { Text } from "../../atoms/text/Text";
import { Address } from "../address/Address";
import { CustomModal } from "../cutomModal/CustomModal";
import { MapView } from "../mapView/MapView";
import style from "./selectedAddress.module.scss";

interface SelectedAddressProps {
  addressSelected: any;
  renderSelectedAddressUi: any;
  title:string;
  addressIcon:string;
  addressBadge:string;
  showEditButton?: boolean;
}

export const SelectedAddressComponent: React.FC<SelectedAddressProps> = ({
  addressSelected,
  renderSelectedAddressUi,
  title,
  addressIcon,
  addressBadge,
  showEditButton = true,
}) => {
  const [isMapModalOpen, setIsMapModalOpen] = useState(false);

  const handleOpenMapModal = () => {
    setIsMapModalOpen(true);
  };

  const handleCloseMapModal = () => {
    setIsMapModalOpen(false);
  };
  return (
    <>
      <BackgroundWrapper className={style.background}>
        <Container className={style.wrapper}>
          <Text text={title} className={style.title} />
          <Address
            leftSideIcon={addressIcon}
            rightSideBadgeText={[addressBadge]}
            line1={addressSelected?.label ||addressSelected?.name|| ""}
            line2={addressSelected?.addressLine1 || addressSelected?.address||""}
            line3={title!=="Selected Drop Location"?`${addressSelected?.addressLine2 || ""}, ${
              addressSelected?.city || ""
            }`:""}
            line4={title!=="Selected Drop Location"?`${addressSelected?.state || ""},${
              addressSelected?.pinCode || ""
            }`:""}
          />
          <div className={style.edit_icon}>
            {showEditButton && <button onClick={renderSelectedAddressUi} className={style.button}>Edit</button>}
            {title === "Selected Pickup Location" && <button onClick={handleOpenMapModal} className={style.button}>See Map View</button>}
          </div>
        </Container>
      </BackgroundWrapper>

      <CustomModal
        modalTitle="Map View"
        isModalOpen={isMapModalOpen}
        isCloseModal={handleCloseMapModal}
      >
        <MapView addressSelected={addressSelected} />
      </CustomModal>
    </>
  );
};
